module.exports = __webpack_public_path__ + "static/media/FlyOut_Triangle@3x.077be6d9.png";